module.exports = __webpack_public_path__ + "img/share3.141d74b5.jpg";